import React from 'react'

import { Stepper, Text } from '@mantine/core'
import { Check } from 'lucide-react'

import { formatDateCustom } from 'src/lib/formatters'

export interface StepperItem {
  id: string
  title: string
  content?: string
  createdAt?: string
  icon?: React.ReactNode
}

interface DnStepperProps {
  items: StepperItem[]
  emptyMessage?: string
  dateFormat?: string
  showIcon?: boolean
  iconComponent?: React.ReactNode
  className?: string
}

const DnStepper = ({
  items = [],
  emptyMessage = 'No items found',
  dateFormat = 'MM/DD/YYYY hh:mm A',
  showIcon = true,
  iconComponent = <Check size={14} strokeWidth={1.5} color="green" />,
  className = '',
}: DnStepperProps) => {
  if (!items || items.length === 0) {
    return (
      <Text size="xs" fw={400} className="text-doubleNickel-gray-500">
        {emptyMessage}
      </Text>
    )
  }

  return (
    <div className={`space-y-2 pb-10 ${className}`}>
      <Stepper
        active={0}
        orientation="vertical"
        color="transparent"
        size="sm"
        iconSize={32}
        classNames={{
          verticalSeparator:
            'border border-dashed border-doubleNickel-gray-300',
          stepIcon: 'bg-transparent border border-doubleNickel-gray-300',
        }}
      >
        {items.map((item) => (
          <Stepper.Step
            icon={showIcon ? item.icon || iconComponent : undefined}
            key={item.id}
            label={item.title}
            description={
              <div className="flex flex-col">
                {item.content && (
                  <Text size="xs" fw={400}>
                    {item.content}
                  </Text>
                )}
                {item.createdAt && (
                  <Text size="xs" fw={400} className="py-6">
                    {formatDateCustom(item.createdAt, dateFormat)}
                  </Text>
                )}
              </div>
            }
          />
        ))}
      </Stepper>
    </div>
  )
}

export default DnStepper
